import React from 'react';

import {Badge, BottomNavigation, BottomNavigationAction, createSvgIcon, Paper} from "@mui/material";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {goBack, goForwardTo} from "../Utils";


const CoolHomeIcon = createSvgIcon(
    <>
        <path
            d="M24.467 8.707 12.745.124a.642.642 0 0 0-.76 0L.264 8.707a.643.643 0 1 0 .76 1.037l11.342-8.305 11.343 8.305a.64.64 0 0 0 .898-.139.642.642 0 0 0-.139-.898Z"

        />
        <path
            d="M21.36 9.89a.643.643 0 0 0-.642.642v10.227h-5.14v-5.582a3.217 3.217 0 0 0-3.213-3.213 3.217 3.217 0 0 0-3.213 3.213v5.583h-5.14V10.532a.643.643 0 0 0-1.285 0v10.87c0 .355.287.643.642.643h6.426a.642.642 0 0 0 .642-.643v-6.225a1.93 1.93 0 0 1 1.928-1.928 1.93 1.93 0 0 1 1.928 1.928v6.225a.642.642 0 0 0 .643.642h6.425a.643.643 0 0 0 .642-.642v-10.87a.643.643 0 0 0-.642-.643Z"

        />
    </>,
    'Home',
);

const CoolExpensesIcon = createSvgIcon(
    <>
<path
    d="M23.736 14.957v-2.393a2.795 2.795 0 0 0-2.793-2.792H18.55V7.354c0-.697-.36-1.327-.965-1.686a1.993 1.993 0 0 0-1.982-.042l-.643.32v-1.3a2.03 2.03 0 0 0-1.19-1.877 1.937 1.937 0 0 0-2.097.316L4.04 9.772h-.249A2.795 2.795 0 0 0 1 12.564v10.37a2.795 2.795 0 0 0 2.792 2.792h17.151a2.795 2.795 0 0 0 2.793-2.792v-2.393c1.1 0 1.994-.895 1.994-1.994V16.95c0-1.1-.895-1.994-1.994-1.994Zm-7.764-8.625c.381-.207.832-.2 1.205.022.36.214.576.587.576 1v2.418H9.076l6.896-3.44Zm-3.774-2.647c.354-.31.819-.382 1.242-.19.35.159.723.544.723 1.15v1.699L7.288 9.772H5.252l6.946-6.087Zm10.74 19.25c0 1.099-.895 1.994-1.994 1.994H3.791c-1.1 0-1.994-.895-1.994-1.995v-10.37c0-1.1.894-1.995 1.994-1.995h17.151c1.1 0 1.995.895 1.995 1.995v2.393h-3.989c-1.994 0-1.994 2.101-1.994 2.792 0 .69 0 2.792 1.994 2.792h3.989v2.393Zm1.994-4.388c0 .66-.537 1.196-1.196 1.196h-4.787c-.718 0-1.196-.34-1.196-1.994 0-1.655.478-1.994 1.196-1.994h4.787c.66 0 1.196.536 1.196 1.196v1.596Z"

    strokeWidth={0.3}
/>
<path
    d="M20.146 16.154c-.88 0-1.596.715-1.596 1.595s.716 1.596 1.596 1.596c.88 0 1.595-.716 1.595-1.596 0-.88-.715-1.595-1.595-1.595Zm0 2.393a.799.799 0 1 1 .001-1.597.799.799 0 0 1-.001 1.597ZM20.19 7.286l-.25.15a.399.399 0 0 0-.034.66l1.596 1.197a.398.398 0 0 0 .46.013l.07-.047a5.603 5.603 0 0 0 2.487-4.273h.525a.677.677 0 0 0 .628-.42.678.678 0 0 0-.123-.715L23.728 1.4A.985.985 0 0 0 22.93 1a.984.984 0 0 0-.797.402l-1.81 2.437a.685.685 0 0 0 .51 1.146h.554c.065.92-.391 1.817-1.197 2.3Zm1.95-2.7a.389.389 0 0 0-.029-.131l-.008-.018v-.001a.397.397 0 0 0-.18-.2c-.078-.043 0-.001 0-.001a.414.414 0 0 0-.197-.048h-.668l1.716-2.31a.191.191 0 0 1 .156-.08c.037 0 .106.011.158.08l1.718 2.31h-.672a.399.399 0 0 0-.398.4 4.81 4.81 0 0 1-1.985 3.896l-.903-.678a3.282 3.282 0 0 0 1.292-3.22Z"

    strokeWidth={0.3}
/>
    </>,
    'Home',
);
const CoolSettlementIcon = createSvgIcon(
    <>
<g clipPath="url(#a)">
    <path d="M26.428 16.657a.406.406 0 0 0-.565-.106 63.728 63.728 0 0 0-2.922 2.122c-.137.106-.39.188-.473.068l-3.327-4.846c-.086-.124.095-.332.234-.416a64.2 64.2 0 0 0 2.098-1.334.406.406 0 1 0-.45-.677c-.67.445-1.367.889-2.07 1.316-.236.144-.419.343-.529.567H8.576a1.385 1.385 0 0 0-.529-.566c-.703-.428-1.4-.871-2.071-1.317a.406.406 0 1 0-.45.677c.68.451 1.386.9 2.1 1.334.25.152.27.364.233.416L4.53 18.74c-.086.124-.338.035-.472-.068a63.84 63.84 0 0 0-2.922-2.122.406.406 0 1 0-.459.67c.97.663 1.94 1.368 2.884 2.095.54.417 1.28.407 1.64-.115l.17-.25c.435.396.515.596.655.911-.099.078-.192.164-.27.269a1.41 1.41 0 0 0 .294 1.97l.051.038c.27.199.578.297.967.262.003.034 0 .069.006.104.057.38.258.716.567.945.298.22.662.327 1.094.255.053.413.262.749.57.976.316.234.706.34 1.153.246a1.299 1.299 0 0 0 2.223.655 1.48 1.48 0 0 0 1.945-.459c.137-.199.215-.424.244-.657l.194.138a1.492 1.492 0 0 0 2.07-.385c.139-.2.217-.428.245-.663.7.42 1.56.197 1.992-.43.138-.202.216-.429.244-.664l.02.014a1.488 1.488 0 1 0 1.684-2.457l-.062-.042.833-.505c.42.25.953.148 1.346-.156a63.042 63.042 0 0 1 2.884-2.095.406.406 0 0 0 .107-.564Zm-19.842 4.83-.05-.038a.598.598 0 0 1 .71-.96l.05.038a.597.597 0 0 1 .196.704l-.166.23a.597.597 0 0 1-.74.025Zm1.54 1.31a.624.624 0 0 1-.15-.849c.069-.075.344-.465.473-.643a.628.628 0 1 1 1.01.747l-.454.614a.628.628 0 0 1-.88.131Zm1.663 1.231a.628.628 0 0 1-.132-.878l.859-1.16a.628.628 0 1 1 1.01.748l-.858 1.159a.628.628 0 0 1-.879.131Zm2.47.793-.117.159a.499.499 0 0 1-.696.104.496.496 0 0 1-.104-.697l.118-.16a.497.497 0 1 1 .8.593Zm8.779-3.19a.676.676 0 0 1-.944.174l-1.109-.752-3.109-2.134a.406.406 0 1 0-.46.67l3.111 2.135a.677.677 0 0 1-.766 1.117l-3.111-2.137a.4.4 0 0 0-.483.026c-.027.018-.049.044-.071.069-.003.004-.008.006-.01.01h-.001c-.012.014-.026.022-.036.037a.406.406 0 0 0 .114.563l2.128 1.409a.677.677 0 0 1-.76 1.12l-2.003-1.427a.406.406 0 1 0-.472.661c.992.756.654.5.727.55a.677.677 0 0 1-.67 1.17 1.298 1.298 0 0 0-.954-1.643l.02-.028a1.44 1.44 0 0 0-1.9-2.093 1.426 1.426 0 0 0-2.056-.691 1.39 1.39 0 0 0-.443-.563l-.05-.038a1.4 1.4 0 0 0-.943-.266c-.182-.401-.314-.742-.95-1.295 2.803-4.101 2.71-3.903 2.79-4.111h1.839a2.804 2.804 0 0 0-1.408 2.429v.506c0 .66.64 1.118 1.258.924.457-.142.834-.475 1.093-.964.532-1.003 1.925-1.008 2.508-.207.302.416.889.911 1.972.911.425 0 .837.126 1.19.365l3.784 2.562c.306.21.387.631.175.941Zm-3.504-4.176a2.926 2.926 0 0 0-1.645-.504c-.595 0-1.037-.194-1.315-.577-.926-1.273-3.062-1.245-3.883.305-.159.299-.366.49-.616.568a.156.156 0 0 1-.205-.148v-.506c0-.721.391-1.387 1.02-1.739l1.238-.69h6.245c.08.208-.042-.032 3.182 4.683l-1.038.628-2.983-2.02Z" />
    <path d="M13.497 13C17.083 13 20 10.084 20 6.5S17.083 0 13.497 0C9.915 0 7 2.916 7 6.5S9.915 13 13.497 13Zm0-11.785A5.293 5.293 0 0 1 18.786 6.5a5.293 5.293 0 0 1-5.289 5.285A5.29 5.29 0 0 1 8.214 6.5a5.29 5.29 0 0 1 5.283-5.285Z" />
    <path d="M13.58 8.106h-1.093c-.269 0-.487.253-.487.567 0 .313.218.567.487.567h.527v.193c0 .313.218.567.487.567.27 0 .488-.254.488-.567v-.272C14.572 8.955 15 8.331 15 7.586c0-.911-.637-1.653-1.42-1.653h-.16c-.245 0-.446-.233-.446-.52 0-.286.2-.519.447-.519h1.092c.269 0 .487-.253.487-.567 0-.313-.218-.567-.487-.567h-.524v-.193c0-.313-.219-.567-.488-.567s-.487.254-.487.567v.27C12.43 4.042 12 4.667 12 5.414c0 .911.637 1.653 1.42 1.653h.16c.245 0 .446.233.446.52 0 .286-.2.519-.447.519Z" />
</g>
<defs>
    <clipPath id="a">
        <path fill="#fff" transform="translate(.5)" d="M0 0h26v26H0z" />
    </clipPath>
</defs>
    </>,
    'Home',
);

const CoolParticipantsIcon = createSvgIcon(
    <>
        <path
            d="M4.554 18.313a.511.511 0 0 1-.07-.005 9.81 9.81 0 0 1-3.222-1.055.495.495 0 0 1 .466-.873c.905.483 1.88.802 2.896.948a.495.495 0 0 1-.07.985ZM22.175 18.313a.495.495 0 0 1-.07-.985 8.79 8.79 0 0 0 2.897-.948.496.496 0 0 1 .466.874 9.814 9.814 0 0 1-3.221 1.054.6.6 0 0 1-.072.005ZM17.002 13.873a.494.494 0 0 1-.414-.765 3.77 3.77 0 0 1 3.168-1.716.494.494 0 1 1 0 .989c-.948 0-1.822.473-2.339 1.267a.493.493 0 0 1-.415.225Z"

        />
        <path
            d="M20.852 12.38c-1.753 0-3.234-1.48-3.234-3.233 0-1.753 1.481-3.234 3.235-3.234 1.752 0 3.233 1.481 3.233 3.234s-1.48 3.234-3.233 3.234Zm0-5.477c-1.216 0-2.244 1.027-2.244 2.244 0 1.217 1.028 2.245 2.244 2.245 1.217 0 2.245-1.028 2.245-2.245s-1.028-2.244-2.245-2.244Z"

        />
        <path
            d="M25.235 15.668a.494.494 0 0 1-.495-.494 2.796 2.796 0 0 0-2.792-2.793.494.494 0 1 1 0-.989 3.786 3.786 0 0 1 3.782 3.782.494.494 0 0 1-.495.494Z"

        />
        <path
            d="M21.948 12.38h-2.192a.494.494 0 1 1 0-.989h2.192a.494.494 0 1 1 0 .99ZM25.235 17.312a.494.494 0 0 1-.495-.495v-1.643a.494.494 0 1 1 .99 0v1.643a.494.494 0 0 1-.495.495ZM7.521 17.677a.494.494 0 0 1-.494-.495 4.883 4.883 0 0 1 4.877-4.877.494.494 0 1 1 0 .99 3.892 3.892 0 0 0-3.888 3.887.494.494 0 0 1-.495.495Z"

        />
        <path
            d="M14.826 13.294h-2.922a.494.494 0 1 1 0-.989h2.922a.494.494 0 1 1 0 .99ZM9.728 13.873a.495.495 0 0 1-.415-.225 2.783 2.783 0 0 0-2.339-1.267.494.494 0 1 1 0-.99 3.77 3.77 0 0 1 3.168 1.717.494.494 0 0 1-.414.765ZM7.521 19.868a.494.494 0 0 1-.494-.494v-2.192a.494.494 0 1 1 .99 0v2.192a.494.494 0 0 1-.496.494Z"

        />
        <path
            d="M13.365 13.294c-2.248 0-4.147-1.899-4.147-4.147S11.118 5 13.365 5c2.248 0 4.147 1.9 4.147 4.147 0 2.248-1.9 4.147-4.147 4.147Zm0-7.305c-1.712 0-3.158 1.446-3.158 3.158s1.446 3.158 3.158 3.158 3.158-1.446 3.158-3.158-1.446-3.158-3.158-3.158Z"

        />
        <path
            d="M19.209 17.677a.494.494 0 0 1-.495-.495 3.892 3.892 0 0 0-3.888-3.888.494.494 0 1 1 0-.989 4.882 4.882 0 0 1 4.877 4.877.494.494 0 0 1-.494.495Z"

        />
        <path
            d="M19.209 19.868a.494.494 0 0 1-.495-.494v-2.192a.494.494 0 1 1 .99 0v2.192a.494.494 0 0 1-.495.494Z"

        />
        <path
            d="M13.365 21.332c-2.087 0-4.174-.507-6.076-1.522a.495.495 0 0 1 .465-.873 11.902 11.902 0 0 0 11.222 0 .496.496 0 0 1 .466.873 12.915 12.915 0 0 1-6.077 1.522ZM5.877 12.38c-1.752 0-3.233-1.48-3.233-3.233 0-1.753 1.48-3.234 3.233-3.234 1.753 0 3.234 1.481 3.234 3.234s-1.48 3.234-3.234 3.234Zm0-5.477c-1.216 0-2.244 1.027-2.244 2.244 0 1.217 1.028 2.245 2.244 2.245 1.217 0 2.245-1.028 2.245-2.245S7.094 6.903 5.877 6.903Z"

        />
        <path
            d="M1.495 15.668A.494.494 0 0 1 1 15.174a3.786 3.786 0 0 1 3.782-3.782.494.494 0 1 1 0 .99 2.795 2.795 0 0 0-2.792 2.792.494.494 0 0 1-.495.494Z"

        />
        <path
            d="M6.973 12.38H4.782a.494.494 0 1 1 0-.989h2.191a.494.494 0 1 1 0 .99ZM1.495 17.312A.494.494 0 0 1 1 16.817v-1.643a.494.494 0 1 1 .99 0v1.643a.494.494 0 0 1-.495.495Z"

        />
    </>,
    'Participants',
);



function SplitBottomNavigation({group}) {
    const ownageMap = {};
    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    return (

        group ? <Paper sx={{boxShadow: "0px -4px 20px rgba(255, 255, 255, 0.1)", position: 'fixed',borderRadius: "20px 20px 0px 0px", bottom: -1, left: 0, right: 0}} elevation={3}>
                <BottomNavigation
                    style={{background: "transparent", height: 64, borderRadius: "20px 20px 0px 0px"}}
                    showLabels
                    value={group && params.view ? (params.view === 'expenses' ? 2 :
                        params.view === 'members' ? 1 : 3) : 0
                    }
                    onChange={(event, newValue) => {

                        if (newValue === 0) {
                            if(!params.view){
                                //do nothing
                            } else {
                                goBack(location,navigate, '/' + group.id);
                            }
                        } if (newValue === 1){

                            goForwardTo(location, navigate, '/' + group.id + '/members', !!params.view);
                        } else if (newValue === 2){
                            goForwardTo(location, navigate, '/' + group.id + '/expenses', !!params.view);
                        } else if (newValue === 3){
                            goForwardTo(location, navigate, '/' + group.id + '/results', !!params.view);
                        }
                    }}
                >
                    <BottomNavigationAction label="Home" icon={<CoolHomeIcon viewBox={"0 0 26 26"}/>}/>
                    <BottomNavigationAction disabled={!group} label="Participants" icon={ <CoolParticipantsIcon viewBox={"0 0 26 26"}/>}/>
                    <BottomNavigationAction disabled={!group} label="Expenses" icon={<CoolExpensesIcon viewBox={"0 0 26 26"}/>}/>
                    <BottomNavigationAction disabled={!group} label="Settlement" icon={
                        <Badge badgeContent={4} invisible={true} variant={"dot"}
                               color={"warning"}>
                            <CoolSettlementIcon  viewBox={"0 0 26 26"}  ></CoolSettlementIcon>
                        </Badge>
                    }/>
                </BottomNavigation>
            </Paper> : <></>

    );
}

export default (SplitBottomNavigation);
